import React from 'react';
import { UnitTransactionTableInterface } from '../utils';
import { mobileNetworkProvisioningEntityTransformer } from '../../../utils/transformers';
import {
    generateColumns,
    MobileNetworkProvisioningTableRowInterface,
    useStyles,
} from './MobileNetworkProvisioning.utils';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../DataGrid/DataGrid';
import { PaginationMode } from '../../DataGrid/types';
import classNames from 'classnames';

const MobileNetworkProvisioning: React.VFC<UnitTransactionTableInterface> = ({
    currency,
    data,
    onPageChange,
    onPageSizeChange,
    initialPageSize,
    loading,
    rowCount,
    userDateTimeFormat,
    ratio,
    unit,
    className,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const columns = generateColumns(t, currency, unit, userDateTimeFormat);

    const items: MobileNetworkProvisioningTableRowInterface[] = data.map(
        (item) => mobileNetworkProvisioningEntityTransformer(item, ratio),
    );

    return (
        <DataGrid<MobileNetworkProvisioningTableRowInterface>
            data={items}
            dataQa={'mobile-network-provisioning'}
            loading={loading}
            columns={columns}
            rowCount={rowCount}
            paginationMode={PaginationMode.Server}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            initialPageSize={initialPageSize}
            classes={{
                header: classes.header,
                tableContainer: classNames(classes.tableContent, className),
            }}
        />
    );
};

export default MobileNetworkProvisioning;
